import { Col, Image, Row, Typography } from "antd";
import { useLoginStore } from "features/login/store";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ReactNode } from "react";
import { DATE_FORMAT } from "std/const/date";

const { Title } = Typography;

export function ImpressaoHeader({ title, customSubTitulo }: { title: string; customSubTitulo?: ReactNode }) {
	const filter = useRelatorioStore((s) => s.filter);

	const empresa = useLoginStore((s) => s.getEmpresa());

	return (
		<div className="relative print-only">
			<div className="flex">
				<div className="flex flex-col items-center justify-center">
					<Image
						src={empresa?.emp_logotipo_foto}
						preview={false}
						style={{
							width: 100,
							height: 100,
						}}
					/>
				</div>

				<div className="flex flex-col items-start justify-start w-full ml-3">
					<Title level={5} className="my-0">
						{empresa?.emp_nome_razaosocial}
					</Title>

					<Title level={2} className={filter ? "m-0" : "my-0"} style={{ fontFamily: "Mukta", textTransform: "uppercase" }}>
						{title}
					</Title>

					<Title level={5} className={filter ? "m-0" : "my-0"} hidden={!customSubTitulo}>
						{customSubTitulo}
					</Title>

					{filter && (
						<Row gutter={10} style={{ marginBottom: "12px", width: "100%" }}>
							{filter?.filterMesRef && (
								<Col xs={12}>
									<p className="my-0">{`Mês de referência:  ${filter?.filterMesRef}`}</p>
								</Col>
							)}

							{filter?.filterData?.start && filter?.filterData?.end && (
								<Col xs={12}>
									<p className="my-0">
										{`Periodo de ${filter.filterData?.start.format(DATE_FORMAT)} a ${filter.filterData?.end.format(DATE_FORMAT)}`}
									</p>
								</Col>
							)}

							{filter?.filterData?.start && !filter?.filterData?.end && (
								<Col xs={12}>
									<p className="my-0">{`Data Inicial: ${filter.filterData?.start.format(DATE_FORMAT)}`}</p>
								</Col>
							)}

							{!filter?.filterData?.start && filter?.filterData?.end && (
								<Col xs={12}>
									<p className="my-0">{`Data Final: ${filter.filterData?.end}`}</p>
								</Col>
							)}

							{filter?.filterProdutores?.length ? (
								<Col xs={12}>
									<p className="my-0">
										{`Produtores: ${filter.filterProdutores.map((produtor) => produtor.pessoa?.pes_nome_razaosocial || produtor.for_codigoindividual).join(", ")}`}
									</p>
								</Col>
							) : null}

							{filter?.filterTransportadores?.length ? (
								<Col xs={12}>
									<p className="my-0">
										{`Transportadores: ${filter.filterTransportadores.map((transportador) => transportador.pessoa?.pes_nome_razaosocial || transportador.tra_codigoindividual).join(", ")}`}
									</p>
								</Col>
							) : null}

							{filter?.filterCnpjCpf && (
								<Col xs={12}>
									<p className="my-0">{`CNPJ/CPF do Produtor: ${filter.filterCnpjCpf}`}</p>
								</Col>
							)}

							{filter?.filterEstado && (
								<Col xs={12}>
									<p className="my-0">{`Estado: ${filter.filterEstado}`}</p>
								</Col>
							)}

							{filter?.filterCidade && (
								<Col xs={12}>
									<p className="my-0">{`Cidade: ${filter.filterCidade?.cid_cidade}`}</p>
								</Col>
							)}

							{filter?.filterBancoIdpk && (
								<Col xs={12}>
									<p className="my-0">{`Banco: ${filter.filterBancoIdpk}`}</p>
								</Col>
							)}

							{filter?.filterRota && (
								<Col xs={12}>
									<p className="my-0">{`Rota: ${filter?.filterRota?.rot_identificacao}`}</p>
								</Col>
							)}

							{filter?.filterTipo && (
								<Col xs={12}>
									<p className="my-0">{`Tipo:  ${filter?.filterTipo}`}</p>
								</Col>
							)}

							{filter?.filterTipoCrio && (
								<Col xs={12}>
									<p className="my-0">{`Tipo de Crioscopia:  ${filter?.filterTipoCrio}`}</p>
								</Col>
							)}

							{filter?.filterTipoConv && (
								<Col xs={12}>
									<p className="my-0">{`Tipo de Conv~enio:  ${filter?.filterTipoConv}`}</p>
								</Col>
							)}
						</Row>
					)}
				</div>
			</div>
		</div>
	);
}
